/* eslint-disable no-prototype-builtins */
import AccountsCollection from '../../collections/accounts/AccountsCollection.js';
import ListsCollection from '../../collections/lists/ListsCollection.js';
import LibraryCollection from '../../collections/manage/LibraryCollection.js';
import InboxServiceCollection from '../../collections/services/InboxServiceCollection.js';
import ServiceCollection from '../../collections/services/ServiceCollection.js';
import ServiceGroupsCollection from '../../collections/services/ServiceGroupsCollection.js';
import StreamAccountCollection from '../../collections/streams/StreamAccountCollection.js';
import UserCollection from '../../collections/users/UserCollection.js';

const cacheManager = Backbone.View.extend({

  initialize() {
    /* AccountsCollection {
            Cache name: GetServices_
            File folder: “accounts/”
            using “cacheUpdate”: true (updateCache)
        } */
    this.accountsCollection = new AccountsCollection();

    /* ListsCollection {
            Cache name: ListCollection_
            File folder: “lists/”,
            using “cacheUpdate”: true (updateCache)
        } */
    this.listsCollection = new ListsCollection();

    /* LibraryCollection {
            Cache name: username + _libraries
            File folder: “manage/”
            using “cacheUpdate”: false
        } */
    this.libraryCollection = new LibraryCollection();

    /* InboxServiceCollection {
            Cache name: username + _inbox_services
            File folder: “services/”
            using “cacheUpdate”: true (clearAllCache)
        } */
    this.inboxServiceCollection = new InboxServiceCollection();

    /* ServiceCollection {
            Cache name: username + _services
            File folder: “services/”
            using “cacheUpdate”: true (clearAllCache)
        } */
    this.serviceCollection = new ServiceCollection();

    /* ServiceGroupsCollection {
            Cache name: SerivceGroups_
            File folder: “services/”
            using “cacheUpdate”: true (updateCache)
        } */
    this.serviceGroupsCollection = new ServiceGroupsCollection();

    /* StreamAccountCollection {
            Cache name: username + _streamAccounts
            File folder: “streams/”
            using “cacheUpdate”: true (resetCache)
        } */
    this.streamAccountCollection = new StreamAccountCollection();

    /* UserCollection {
            Cache name: username + _users
            File folder: “streams/”
            using “cacheUpdate”: false
        } */
    this.userCollection = new UserCollection();
  },

  clean(argumentArray) {
    _.each(argumentArray, _.bind(function (item) {
      if (item === 'accounts') {
        this.cleanAccounts();
        return;
      }

      if (item === 'lists') {
        this.cleanLists();
        return;
      }

      if (item === 'library') {
        this.cleanLibrary();
        return;
      }

      if (item === 'inboxService') {
        this.cleanInboxService();
        return;
      }

      if (item === 'service') {
        this.cleanService();
        return;
      }

      if (item === 'serviceGroups') {
        this.cleanServiceGroups();
        return;
      }

      if (item === 'streamAccount') {
        this.cleanStreamAccount();
        return;
      }

      if (item === 'user') {
        this.cleanUser();
        return;
      }

      if (item === 'composeTags') {
        this.cleanComposeTags();
      }
    }, this));
  },

  cleanProfile(profile) {
    if (profile === 'allCache') {
      this.clean(['accounts', 'serviceGroups', 'streamAccount', 'inboxService', 'lists']);
      return;
    }

    if (profile === 'addService') {
      this.clean(['accounts', 'serviceGroups', 'streamAccount', 'inboxService']);
    }
  },

  cleanAccounts() {
    this.accountsCollection.updateCache();
  },

  cleanLists() {
    this.listsCollection.updateCache();
  },

  cleanLibrary() {

  },

  cleanInboxService() {
    this.inboxServiceCollection.clearAllCache();
  },

  cleanService() {
    this.serviceCollection.clearAllCache();
  },

  cleanServiceGroups() {
    this.serviceGroupsCollection.updateCache();
  },

  cleanStreamAccount() {
    this.streamAccountCollection.resetCache();

    Backbone.trigger('reset:polling');
  },

  cleanUser() {
    this.userCollection.clearCache();
  },

  cleanComposeTags() {
    this.loopAndDeleteCacheKeys('fbTag');
    this.loopAndDeleteCacheKeys('TwTag');
  },

  updateCache(cachePrefix) {
    // eslint-disable-next-line
    const cache = new Cache();

    // process cache keys
    const key = this.processCacheKey(cachePrefix, '');

    if (window.localStorage) {
      this.loopAndDeleteCacheKeys(key);
    }
  },

  loopAndDeleteCacheKeys(key) {
    let item;

    for (let index = 0, storageLength = localStorage.length; index < storageLength; ++index) {
      item = window.localStorage.key(index);

      if (item !== null && item !== undefined && item.match(key)) {
        window.localStorage.removeItem(item);
      }
    }
  },

  processCacheKey(cachePrefix, params) {
    let key = cachePrefix;
    const keyObjects = $.extend(true, {}, params);
    const { username } = loginContext.getCurrentDetails();

    if (keyObjects.hasOwnProperty('list_type')) keyObjects.list_type = keyObjects.list_type.replace(',', '');

    key += username || '';
    key += keyObjects.type || '';
    key += keyObjects.list_type || '';

    return key;
  },

});

export default cacheManager;
